<template>
  <div class="div">
    <el-tabs v-model="activeName" type="card" style="height: 100%">
      <el-tab-pane label="电消耗" name="电">
        <ElectricityData
          ref="ElectricityData"
          v-if="activeName === '电'"
        ></ElectricityData>
      </el-tab-pane>
      <el-tab-pane label="水消耗" name="水">
        <WaterData ref="WaterData" v-if="activeName === '水'"></WaterData>
      </el-tab-pane>
      <el-tab-pane label="气消耗" name="气">
        <GasData ref="GasData" v-if="activeName === '气'"></GasData>
      </el-tab-pane>
      <el-tab-pane label="油消耗" name="油">
        <OilData ref="OilData" v-if="activeName === '油'"></OilData>
      </el-tab-pane>
      <el-tab-pane label="供热" name="暖">
        <HeatingData ref="HeatingData" v-if="activeName === '暖'"></HeatingData>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import ElectricityData from "./ElectricityData/ElectricityData.vue";
import WaterData from "./WaterData/WaterData.vue";
import GasData from "./GasData/GasData.vue";
import OilData from "./OilData/OilData.vue";
import HeatingData from "./HeatingData/HeatingData.vue";
export default {
  data() {
    return {
      activeName: "电",
    };
  },
  props: {},
  components: {
    ElectricityData,
    OilData,
    WaterData,
    GasData,
    HeatingData,
  },
  methods: {},
  mounted() {},
  created() {},
  computed: {},
  watch: {},
};
</script>
<style lang="scss" scoped>
::v-deep .el-tabs__content {
  height: calc(100% - 37px);
  .el-tab-pane {
    height: 100%;
  }
}
</style>
